import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = "https://nc8.olharfixo.com.br/Customers/api/v3/Customers";




async function search(payload) {
  
  try {
    let response = await api.get(`${basePath}`, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(
      response,
      "clientService.search"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "clientService.search");
    return null;
  }
}

async function fetchClient(id) {
  try {
    let response = await api.get(`${basePath}/${id}`);

    let treated = errorHandling.handleResponse(
      response,
      "clientService.fetchClient"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "clientService.fetchClient");
    return null;
  }
}


export const clientService = {
  search,
  fetchClient
};
